<template>
    <div>
        <div class="container-fluid">
            <div class="row">
                <div class="col-md-12">
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{path:'/dashboard'}">Inicio</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Jugadores</li>
                        </ol>
                    </nav>
                </div>

                <div class="col-md-12" style="margin-bottom: 20px">
                    <div class="input-group">
                        <input type="text" class="form-control" placeholder="Buscar jugador"
                               v-model="searchQuery"
                               @keyup.enter.prevent="searchPlayers">
                        <div class="input-group-append">
                            <button class="btn btn-primary" type="button" @click="searchPlayers">
                                <i class="fa fa-search"></i>
                            </button>
                            <button class="btn btn-primary" type="button" @click="removeSearch">
                                <i class="fa fa-times"></i>
                            </button>
                        </div>
                    </div>
                </div>

                <div class="col-md-3" style="margin-bottom: 20px">
                    <label><strong>Año nacimiento</strong></label>
                    <select name="" class="form-control" v-model="idYear" @change="filterPlayers">
                        <option value="99">Todos los años</option>
                        <option value="2019">2019</option>
                        <option value="2018">2018</option>
                        <option value="2017">2017</option>
                        <option value="2016">2016</option>
                        <option value="2015">2015</option>
                        <option value="2014">2014</option>
                        <option value="2013">2013</option>
                        <option value="2012">2012</option>
                        <option value="2011">2011</option>
                        <option value="2010">2010</option>
                        <option value="2009">2009</option>
                        <option value="2008">2008</option>
                        <option value="2007">2007</option>
                        <option value="2006">2006</option>
                        <option value="2005">2005</option>
                        <option value="2004">2004</option>
                        <option value="2003">2003</option>
                        <option value="2002">2002</option>
                    </select>
                </div>

                <div class="col-md-2" style="margin-bottom: 20px" v-if="0 === reserva">
                    <label style="display: block">&nbsp;</label>
                    <router-link to="/admin/jugadores/baja" v-if="0 === baja">
                        <button class="btn btn-warning">
                            <i class="fas fa-clock"></i> Ver jugadores de baja
                        </button>
                    </router-link>
                    <router-link to="/admin/jugadores" v-else>
                        <button class="btn btn-success">
                            <i class="fas fa-clock"></i> Ver jugadores de alta
                        </button>
                    </router-link>
                </div>

                <div class="col-md-12" style="margin-bottom: 20px">

                    <p style="font-size: 1.2em"><strong>Total de jugadores: {{ totalPlayers }}</strong></p>

                    <div class="card">
                        <div class="table-responsive">
                            <table class="table table-striped text-nowrap" id="table-players">
                                <thead>
                                <tr>
                                    <th>Nombre</th>
                                    <th>Año nacimiento</th>
                                    <th>Sede</th>
                                    <th>Club</th>
                                    <th>Modalidad</th>
                                </tr>
                                </thead>

                                <tbody>
                                <tr v-for="player in players">
                                    <th>
                                        <div class="media align-items-center">

                                            <img alt="Image placeholder" :src="player.img"
                                                 class="avatar rounded-circle mr-3">

                                            <div class="media-body">
                                                <router-link :to="{path: '/jugadores/'+player.id}">
                                                    <span class="name mb-0 text-sm"
                                                          id="name-player">{{
                                                            player.apellidos | capitalizeText
                                                        }}, {{ player.nombre | capitalizeText }} </span>
                                                </router-link>
                                            </div>
                                        </div>

                                    </th>
                                    <td class="align-middle">
                                        {{ player.year }}
                                    </td>
                                    <td class="align-middle">
                                        {{ player.inscripcion.hora1.sede }} / {{ player.inscripcion.hora1.dia }}
                                    </td>
                                    <td class="align-middle">
                                        {{ player.club }}
                                    </td>
                                    <td class="align-middle">
                                        {{ player.inscripcion.modalidad | parseModalidad }}
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" v-if="!isFilter && !isSearch && pagination.lastPage > 1">
                    <nav aria-label="Page navigation example">
                        <ul class="pagination">
                            <li class="page-item" :class="{'disabled': pagination.currentPage == 1}">
                                <router-link class="page-link"
                                             :to="{path: pathPaginas+(pagination.currentPage-1)}">&laquo;
                                </router-link>
                            </li>
                            <li v-for="n in pagination.lastPage" class="page-item"
                                :class="{'active': (pagination.currentPage == undefined && n == 1) || n == pagination.currentPage}">
                                <router-link class="page-link" :to="{path: pathPaginas+n}">{{ n }}
                                </router-link>

                            </li>
                            <li class="page-item" :class="{'disabled': pagination.currentPage == pagination.lastPage}">
                                <router-link class="page-link"
                                             :to="{path: pathPaginas+(parseInt(pagination.currentPage)+1)}">
                                    &raquo;
                                </router-link>
                            </li>
                        </ul>
                    </nav>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import swal from 'sweetalert2'
import BTooltipDirective from 'bootstrap-vue/es/directives/tooltip'


export default {
    data() {
        return {
            searchQuery: this.$route.params.searchQuery,
            isSearch: false,
            isFilter: false,
            pagination: {
                currentPage: this.$route.params.pag,
                lastPage: 1,
                nextPageUrl: "",
                prevPageUrl: "",
                total: 1
            },
            pathPaginas: '/admin/jugadores/pagina/',
            idYear: 99,
            yearBirthday: 0,
            players: [],
            baja: 0,
            reserva: 0,
            totalPlayers: 0
        };
    },
    directives: {
        'b-tooltip': BTooltipDirective
    },
    created() {
        if (this.$route.params.baja === 'baja') {
            this.baja = 1;
        }

        if (this.searchQuery !== undefined) {
            this.searchPlayers();
            this.isSearch = true;
        } else {
            if (this.pagination.currentPage === undefined) {
                this.pagination.currentPage = 1;
            }
            this.loadPlayers();
        }
    },
    methods: {
        loadPlayers() {
            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'players', {
                params: {
                    baja: vm.baja,
                    page: vm.pagination.currentPage,
                    jwt: vm.$store.getters.jwt,
                    season: vm.$store.getters.season
                }
            }).then(response => {
                if (response.data.response) {
                    vm.players = response.data.result.data;

                    vm.totalPlayers = response.data.result.totalPlayers;
                    vm.pagination.lastPage = response.data.result.last_page;
                    vm.pagination.nextPageUrl = response.data.result.next_page_url;
                    vm.pagination.prevPageUrl = response.data.result.prev_page_url;
                    vm.pagination.total = response.data.result.total
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        filterPlayers() {
            if (this.idYear == 99) {
                this.isFilter = false;
            } else {
                this.isFilter = true;
            }

            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'players-filter', {
                params: {
                    baja: vm.baja,
                    idYear: vm.idYear,
                    jwt: vm.$store.getters.jwt,
                    season: vm.$store.getters.season
                }
            }).then(response => {
                if (response.data.response) {
                    vm.players = response.data.result.data;
                    vm.totalPlayers = response.data.result.total ? response.data.result.total : vm.players.length;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        searchPlayers() {
            this.$router.push({path: '/admin/jugadores/buscar/' + this.searchQuery});
            this.isSearch = true;

            let vm = this;
            axios.get(this.$store.getters.apiUrl + 'players-search', {
                params: {
                    baja: vm.baja,
                    searchQuery: vm.searchQuery,
                    jwt: vm.$store.getters.jwt,
                    season: vm.$store.getters.season
                }
            }).then(response => {
                if (response.data.response) {
                    vm.players = response.data.result;
                    vm.totalPlayers = vm.players.length;
                } else {
                    swal({
                        title: 'Atención',
                        text: response.data.message,
                        confirmButtonClass: 'btn btn-info btn-fill',
                        type: 'error'
                    });

                }
            }).catch(e => {
                swal({
                    title: 'Atención',
                    text: e,
                    confirmButtonClass: 'btn btn-info btn-fill',
                    type: 'error'
                });

            });
        },
        removeSearch() {
            this.searchQuery = "";
            this.isSearch = false;
            this.pagination.currentPage = 1;
            this.$router.push({path: '/admin/jugadores'});
            this.loadPlayers();
        },
    },
    watch: {
        '$route'(to, from) {
            if (to.params.searchQuery) {
                this.searchPlayers();
            } else {
                if (to.params.pag) {
                    this.pagination.currentPage = to.params.pag;
                } else {
                    this.pagination.currentPage = 1;
                }

                if (to.params.baja === 'baja') {
                    this.baja = 1;
                    this.pathPaginas = '/admin/jugadores/baja/pagina/';
                } else {
                    this.baja = 0;
                    this.pathPaginas = '/admin/jugadores/pagina/';
                }

                this.loadPlayers();
            }
        }
    },

};
</script>
<style scoped>

.container-fluid {
    margin-top: 39px;
}

.card {
    background-color: #f7fafc !important;
    box-shadow: 0 0 2rem 0 rgba(136, 152, 170, 0.30) !important;
    border: 1px solid rgba(0, 0, 0, .05);
    border-radius: .375rem;
}

#table-players tbody tr:hover {
    background-color: rgba(62, 92, 75, 0.3);
}

#table-players tbody tr:hover #name-player {
    text-decoration: underline;
}


</style>
